export default __webpack_public_path__ + "static/media/check-icon.4336cf21.svg";